export default __webpack_public_path__ + "static/logo-98e8a9881806dd695e978d58d35f2e11.png";